<template>
  <administrators-table :tier="tierType" />
</template>

<script setup lang="ts">
import AdministratorsTable from "@/modules/Settings/views/Common/AdministratorsTable/AdministratorsTable.vue";
import { useI18n } from "vue-i18n";
import { computed } from "vue";
import { TIER } from "@/constants";
import { EXTERNAL_DOCS_LINKS } from "@/constants/externalDocsLinks.ts";
import { usePageMetaStore } from "@/store/pageMeta.store";

const pageMetaStore = usePageMetaStore();
const { t } = useI18n();

const tierType = computed(() => TIER.customer);

pageMetaStore.setPageTitle({
  title: t("administrators"),
  info: {
    docsLink: EXTERNAL_DOCS_LINKS.CUSTOMER_ADMINISTRATORS_TABLE,
    text: t("administrators-page"),
  },
});
</script>
